import { render, staticRenderFns } from "./ModalImagem.vue?vue&type=template&id=6d1ce746&scoped=true"
import script from "./ModalImagem.vue?vue&type=script&lang=js"
export * from "./ModalImagem.vue?vue&type=script&lang=js"
import style0 from "./ModalImagem.vue?vue&type=style&index=0&id=6d1ce746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ce746",
  null
  
)

export default component.exports